import React from "react";
import {Outlet, Navigate, useLocation} from "react-router-dom";
import {useSelector} from "react-redux";
import {basePath, loginPath, userSetupPath} from "./routes";
import {altaExplicitamentePendiente} from "../../infrastructure/utils/normalizeRegistro";

const readCachedUserData = () => {
  try {
    const raw = localStorage.getItem("userData");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const PrivateRoute = () => {
  // 1️⃣ Token en Redux
const authToken = useSelector(state => state.authToken?.token);
  // 2️⃣ O token en localStorage como fallback
const localToken = localStorage.getItem("token");
const isLoggedIn = !!(authToken || localToken);
  const location = useLocation();
  // Si NO está logueado, va a LOGIN
  if (!isLoggedIn) {
    return <Navigate to={basePath} replace />;
  }

  // Una cuenta con el alta incompleta (Estatus/Registro aun no activados en
  // backend, ver uspDatosComplementarios) podia entrar a cualquier ruta
  // privada con solo tener un token valido -- el backend la rechaza despues
  // con 401 "Usuario inactivo o eliminado." en cada llamada, que el
  // interceptor global confundia con sesion vencida. `registro` ausente NO
  // cuenta como alta pendiente (VIVA-1019/normalizeRegistro) para no atrapar
  // cuentas ya completas cuyo cache no trae ese campo.
  const cachedUser = readCachedUserData();
  const isOnSetupRoute = location.pathname.replace(/\/+$/, "") === userSetupPath;
  if (altaExplicitamentePendiente(cachedUser?.registro) && !isOnSetupRoute) {
    return <Navigate to={userSetupPath} replace />;
  }

  // Si está logueado, muestra la ruta protegida
  return <Outlet />;
};